/* ECEO · Avis clients : carrousel, défilement automatique lent, vidéos.
   Robuste au re-rendu des sections : tout est rattaché à l'élément au moment où il apparaît. */
(function(){
  if(window.__eceoRv) return; window.__eceoRv=true;
  var SPEED=0.35, AUTO=!window.matchMedia('(prefers-reduced-motion: reduce)').matches, last=0;
  function bind(root){
    var track=root.querySelector('[data-track]'); if(!track || track._rv) return;
    var st=track._rv={pos:track.scrollLeft,paused:0,hover:false,down:false,sx:0,sl:0,moved:false};
    var prev=root.querySelector('[data-dir="-1"]'), next=root.querySelector('[data-dir="1"]');
    function hold(ms){ st.paused=Date.now()+(ms||6000); }
    function free(){ track.style.scrollSnapType=''; track.style.scrollBehavior=''; }
    function pad(){ var h=root.querySelector('.eceo-rv__head'); if(h) track.style.setProperty('--pad', Math.max(16, h.getBoundingClientRect().left)+'px'); }
    function step(){ var c=track.children[1]||track.children[0]; return c.getBoundingClientRect().width+18; }
    function upd(){ if(!prev||!next) return; var max=track.scrollWidth-track.clientWidth-2; prev.disabled=track.scrollLeft<=2; next.disabled=track.scrollLeft>=max; }
    st.hold=hold; st.free=free;
    if(prev) prev.addEventListener('click',function(){ hold(); free(); track.scrollBy({left:-step()*2,behavior:'smooth'}); });
    if(next) next.addEventListener('click',function(){ hold(); free(); track.scrollBy({left:step()*2,behavior:'smooth'}); });
    track.addEventListener('mouseenter',function(){ st.hover=true; free(); });
    track.addEventListener('mouseleave',function(){ st.hover=false; });
    track.addEventListener('touchstart',function(){ hold(8000); free(); },{passive:true});
    track.addEventListener('wheel',function(){ hold(6000); },{passive:true});
    track.addEventListener('scroll',function(){ requestAnimationFrame(upd); },{passive:true});
    window.addEventListener('resize',function(){ pad(); upd(); }); pad(); upd();
    track.addEventListener('pointerdown',function(e){ if(e.pointerType!=='mouse') return; st.down=true; st.moved=false; st.sx=e.clientX; st.sl=track.scrollLeft; });
    window.addEventListener('pointermove',function(e){ if(!st.down) return; var dx=e.clientX-st.sx; if(Math.abs(dx)>5){ st.moved=true; track.classList.add('is-drag'); } if(st.moved) track.scrollLeft=st.sl-dx; });
    window.addEventListener('pointerup',function(){ if(!st.down) return; st.down=false; hold(6000); if(st.moved){ var w=step(), i=Math.round(track.scrollLeft/w); track.classList.remove('is-drag'); free(); track.scrollTo({left:i*w,behavior:'smooth'}); } });
    track.addEventListener('dragstart',function(e){ e.preventDefault(); });
    var vids=root.querySelectorAll('[data-rv-video]');
    if(vids.length && 'IntersectionObserver' in window){
      var vo=new IntersectionObserver(function(es){ es.forEach(function(en){ var v=en.target;
        if(en.isIntersecting){ if(!v.src && v.dataset.src) v.src=v.dataset.src; var p=v.play(); if(p&&p.then) p.then(function(){ v.closest('.eceo-rv__card').classList.add('is-playing'); }).catch(function(){}); }
        else { v.pause(); } }); },{threshold:.5});
      vids.forEach(function(v){ vo.observe(v); });
    }
  }
  function tick(t){
    var dt=last?Math.min(t-last,50):16; last=t;
    document.querySelectorAll('.eceo-rv').forEach(function(root){
      bind(root);
      var track=root.querySelector('[data-track]'); if(!track || !track._rv) return;
      var st=track._rv, rb=track.getBoundingClientRect(), vis=rb.bottom>0 && rb.top<window.innerHeight && rb.height>0;
      if(AUTO && vis && !st.hover && !st.down && Date.now()>st.paused){
        var max=track.scrollWidth-track.clientWidth;
        if(track.scrollLeft>=max-1){ st.hold(4000); setTimeout(function(){ st.free(); track.scrollTo({left:0,behavior:'smooth'}); st.pos=0; },1500); }
        else { if(Math.abs(track.scrollLeft-st.pos)>2) st.pos=track.scrollLeft; st.pos+=SPEED*dt/16; track.style.scrollSnapType='none'; track.style.scrollBehavior='auto'; track.scrollLeft=st.pos; }
      } else if(!st.down && Date.now()>st.paused-3000){ st.pos=track.scrollLeft; }
    });
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();
